import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import type { AppMenu } from '@modules/sidebar/utils';
import { AppModule } from '@modules/core/plugins/AppModule';
import { useI18n } from '@modules/i18n/composables';
import {
  ADMIN_PARTNERS_MENU_ITEM,
  TRANSLATION_GROUP_SIDEBAR,
} from '@modules/sidebar/constants';

import {
  ADMIN_BULK_EMAILS_ROUTE_NAME,
  BULK_EMAILS_PERMISSIONS,
  TRANSLATION_GROUP_BULK_EMAILS,
} from './constants';
import { getTranslationKeys } from './translations';

export class BulkEmailsModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addAdminRoute({
      name: ADMIN_BULK_EMAILS_ROUTE_NAME,
      path: 'partners-emails',
      permission: BULK_EMAILS_PERMISSIONS.SHOW,
      component: () => import('./pages/BulkEmailsPage/BulkEmailsPage.vue'),
    });
  }

  addMenu(menu: AppMenu): void {
    const { getTPath } = useI18n();

    menu.addChildAdminMenuItem(ADMIN_PARTNERS_MENU_ITEM, {
      caption: getTPath(TRANSLATION_GROUP_SIDEBAR, 'PARTNERS_PARTNERS_MAILING'),
      to: {
        name: ADMIN_BULK_EMAILS_ROUTE_NAME,
      },
      permission: BULK_EMAILS_PERMISSIONS.SHOW,
      id: ADMIN_BULK_EMAILS_ROUTE_NAME,
      order: 60,
    });
  }

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_BULK_EMAILS, getTranslationKeys);
  }
}
